exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellBooleanType[data-v-04ec3d04] {\n    text-align: center;\n}\n", ""]);

// exports
